<template>
    <Layout class="tokens-page" :content-class="'content--narrow'" is-crm>
        <template v-if="!(schema && customer)">
            <Spinner />
        </template>
        <template v-else>
            <header class="page__top">
                <h1 v-t="'crm.tokens.title'" />
                <div class="tokens-page__toolbar">
                    <TokensCreate
                        v-if="customer.permissions.token"
                        :schema="schema"
                        :customer-id="$route.params.customer"
                        @created="fetchTokensResource"
                    >
                        <template #trigger="{ open }">
                            <button
                                v-t="'crm.tokens.create.trigger'"
                                class="button button--big"
                                @click.prevent="open"
                            />
                        </template>
                    </TokensCreate>
                </div>
            </header>

            <PaginatedResource
                ref="tokensResource"
                :fetch-method="fetchCustomersMembersTokens"
                :sorting-fields="sortingFields"
                :filter-fields="{ customer_member__customer: $route.params.customer }"
            >
                <template
                    #default="{
                        loading,
                        sort,
                        canLoadMore,
                        resource: tokens,
                        isEmpty,
                        notFound,
                        loadMore,
                    }"
                >
                    <div class="customers-members">
                        <Spinner v-if="loading" />
                        <TokensTable
                            v-if="!isEmpty"
                            :tokens="tokens"
                            :sorting-fields="sortingFields"
                            class="tokens-page__table"
                            @sort="sort"
                            @deleted="fetchTokensResource"
                        />

                        <div v-if="isEmpty" class="tokens-page__alert tokens-page__alert--empty">
                            <p v-t="'crm.tokens.list.empty'" />
                        </div>
                        <div
                            v-else-if="notFound"
                            class="tokens-page__alert tokens-page__alert--notfound"
                        >
                            <p v-t="'crm.tokens.list.notFound'" />
                        </div>
                        <div v-if="canLoadMore" class="tokens-page__loadmore">
                            <button
                                v-t="'misc.loadmore'"
                                class="button button--big button--blank"
                                type="button"
                                @click="loadMore"
                            />
                        </div>
                    </div>
                </template>
            </PaginatedResource>
        </template>
    </Layout>
</template>

<script>
import { fetchCustomersMembersTokens } from '../../api/tokens';
import { fetchCustomer } from '../../../customers/api/customers';
import { TokensCreate, TokensTable } from '../../components';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'TokensPage',
    components: {
        Layout,
        Spinner,
        PaginatedResource,
        TokensCreate,
        TokensTable,
    },
    data() {
        return {
            customer: undefined,
            sortingFields: ['name'],
        };
    },
    computed: {
        ...mapState('customersMember', {
            schema: ({ schema }) => schema.token,
        }),
    },
    async created() {
        try {
            await Promise.all([this.fetchSchema(), this.fetchCustomer()]);
        } catch (err) {
            this.error = err;
            console.log(err);
        }
    },
    methods: {
        ...mapActions('customersMember', ['fetchSchema']),

        fetchCustomersMembersTokens,
        fetchTokensResource() {
            this.$refs.tokensResource.fetch();
        },
        async fetchCustomer() {
            const { customer } = this.$route.params;
            this.customer = await fetchCustomer(customer);
        },
    },
};
</script>

<style lang="scss" src="./TokensPage.scss"></style>
